/**
 * Route for `dpa`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DpaPage } from "../features/dpa/DpaPage";

export const dpaRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/dpa",
	component: DpaPage,
});

export default dpaRoute;
